import { render } from "./PageFormKarakteristikUmum.vue?vue&type=template&id=47994c1c"
import script from "./PageFormKarakteristikUmum.vue?vue&type=script&lang=js"
export * from "./PageFormKarakteristikUmum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__